export default "__VITE_ASSET__DYOrPYgL__"